import domReady from '@wordpress/dom-ready';
import { saveSvgAsPng } from 'save-svg-as-png';

domReady( function () {
	const imageOptions = {
		scale: 2,
		encoderOptions: 1,
		backgroundColor: 'white',
	};

	const downloadQrBtn = document.querySelector(
		'.wp-block-corsan-utilities-vcard--qr-download'
	);

	downloadQrBtn.addEventListener( 'click', ( event ) => {
		event.preventDefault();
		saveSvgAsPng(
			document.querySelector(
				'.wp-block-corsan-utilities-vcard--qr svg'
			),
			'contact-qr.png',
			imageOptions
		);
	} );
} );
